module.exports = __webpack_public_path__ + "static/media/card-main2.7761f9ad.png";